import { render, staticRenderFns } from "./RsaEquipeModalEditComponent.vue?vue&type=template&id=0134b790"
import script from "./RsaEquipeModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaEquipeModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports